export default "__VITE_ASSET__XTLaaz7z__"